<h1 mat-dialog-title>
    <div class="one-row">
        <mat-icon color="accent" style="margin-right: 8px">new_releases</mat-icon>
        <span>Was ist neu?</span>
        <span class="spacer"></span>
        <span *ngIf="currentStep" class="step-counter">
            Schritt {{ currentStep.globalStepNumber }} von {{ currentStep.globalTotalSteps }}
        </span>
    </div>
</h1>

<div mat-dialog-content class="dialog-content" *ngIf="currentStep as step">
    <mat-progress-bar color="accent" mode="determinate" [value]="progressPercent"></mat-progress-bar>

    <div class="tour-meta one-row">
        <span class="version-badge">Version {{ step.version }}</span>
        <span *ngIf="step.kundenportalOnly" class="kundenportal-badge">Kundenportal</span>
        <span class="feature-badge">{{ step.featureTitle }}</span>
        <span *ngIf="step.totalStepsInFeature > 1" class="feature-step-badge">
            {{ step.stepNumber }}/{{ step.totalStepsInFeature }}
        </span>
    </div>

    <div class="step-dots-host">
        <div class="step-dots" *ngIf="currentFeatureSteps.length > 1">
            <button
                *ngFor="let featureStep of currentFeatureSteps; let i = index"
                type="button"
                class="step-dot"
                [class.active]="i === currentFeatureStepIndex"
                [class.completed]="i < currentFeatureStepIndex"
                [attr.aria-label]="'Schritt ' + featureStep.stepNumber + ' von ' + featureStep.totalStepsInFeature"
                (click)="goToFeatureStep(i)"
            ></button>
        </div>
    </div>

    <div class="tour-step" [class.tour-step--section-intro]="step.sectionIntro" [class.tour-step--kundenportal]="step.kundenportalOnly">
        <h2 class="step-title">{{ step.title }}</h2>
        <p class="step-description">{{ step.description }}</p>

        <div class="media-slot">
            <img
                *ngIf="step.image"
                [src]="step.image"
                [alt]="step.title"
                class="step-image"
                title="Klicken zum Vergrößern"
                (click)="openImageFullscreen(step.image)"
            />

            <video *ngIf="step.video && !isYoutubeVideo(step.video)" class="step-video" controls playsinline>
                <source [src]="step.video" />
                Ihr Browser unterstützt keine eingebetteten Videos.
            </video>

            <iframe
                *ngIf="step.video && isYoutubeVideo(step.video)"
                class="step-video-embed"
                [src]="getYoutubeEmbedUrl(step.video)"
                title="Anleitungsvideo"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </div>

        <div class="route-slot">
            <div *ngIf="step.route" class="route-hint">
                <button mat-stroked-button color="accent" (click)="tryRoute(step.route)">
                    <mat-icon>open_in_new</mat-icon>
                    Zum Bereich wechseln
                </button>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="actions-corners">
    <div>
        <button *ngIf="data.showAllReleaseNotesLink" mat-button color="accent" (click)="openAllReleaseNotes()">
            Alle Release Notes
        </button>
    </div>
    <div class="action-buttons">
        <button mat-button (click)="spaeter()">Später</button>
        <button mat-button [disabled]="isFirstStep" (click)="previous()">Zurück</button>
        <button *ngIf="!isLastStep" mat-flat-button color="accent" (click)="next()">Weiter</button>
        <button *ngIf="isLastStep" mat-flat-button color="accent" (click)="verstanden()">Verstanden</button>
    </div>
</div>
